import { jsx as _jsx } from "react/jsx-runtime";
import { FieldViewType } from "../viewType";
import CurrencyFieldDetail from "./detail";
export default function CurrencyFieldList(_a) {
    var fieldName = _a.fieldName, record = _a.record;
    return (_jsx(CurrencyFieldDetail, { fieldName: fieldName, record: record, viewType: FieldViewType.DETAIL }));
}
